import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

// Catches render-time exceptions (a different beast from fetch errors, which the
// error bus handles). Without this, a render crash blanks the whole screen; here we
// show a fallback with a reload instead.
export default class ErrorBoundary extends React.Component<
    { children: React.ReactNode },
    { crashed: boolean }
> {
    constructor(props: { children: React.ReactNode }) {
        super(props)
        this.state = { crashed: false }
    }

    static getDerivedStateFromError(): { crashed: boolean } {
        return { crashed: true }
    }

    componentDidCatch(error: unknown) {
        console.error('Render error caught by ErrorBoundary:', error)
    }

    render() {
        if (this.state.crashed) {
            return (
                <Box sx={{ p: 2, display: 'flex', flexFlow: 'column nowrap', alignItems: 'flex-start', gap: 1 }}>
                    <p>Något gick fel.</p>
                    <Button variant="outlined" onClick={() => window.location.reload()}>Ladda om sidan</Button>
                </Box>
            )
        }
        return this.props.children
    }
}
